import {getService} from "../globalMethods/myConfig";

const getServerEndPoint = () => {
    return getService()
}


export {getServerEndPoint}